import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ArticleDetailPage.css';
import FavoriteToggle from '../components/FavoriteToggle';
import { getUserId } from '../utils/auth';

const ArticleDetailPage = () => {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        // Récupérer l'ID de l'article depuis l'URL
        const urlParams = new URLSearchParams(window.location.search);
        const articleId = urlParams.get('id');
        
        if (!articleId) {
          setError('ID d\'article non spécifié');
          setLoading(false);
          return;
        }
        
        // Récupérer l'ID utilisateur
        const userId = getUserId();
        
        // Inclure l'ID utilisateur dans la requête
        const params = { userId };
        const response = await axios.get(`http://localhost:5001/api/articles/${articleId}`, { params });
        
        if (response.data.success) {
          setArticle(response.data.data);
        } else {
          setError('Erreur lors du chargement de l\'article');
        }
      } catch (err) {
        console.error('Erreur lors du chargement de l\'article:', err);
        setError('Erreur de connexion au serveur');
      } finally {
        setLoading(false);
      }
    };
    
    fetchArticle();
  }, []);

  if (loading) {
    return <div className="article-detail-page loading">Chargement...</div>;
  }

  if (error) {
    return <div className="article-detail-page error">{error}</div>;
  }

  if (!article) {
    return <div className="article-detail-page not-found">Article non trouvé</div>;
  }

  return (
    <div className="article-detail-page">
      <div className="future-development-area">
        <div className="favorite-area">
          <div className="favorite-label">Ajouter aux favoris:</div>
          <FavoriteToggle 
            articleId={article.ID} 
            initialState={article.isFavorite} 
          />
        </div>
      </div>
      
      <div className="article-card">
        <h1 className="article-title">{article.Title}</h1>
        
        <div className="article-image-container">
          <img 
            src={article.Picture} 
            alt={article.Title} 
            className="article-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://via.placeholder.com/800x400?text=Image+non+disponible";
            }}
          />
        </div>
        
        <div className="article-metadata">
          <span className="metadata-item">OEM: {article.OEM}</span>
          <span className="metadata-item">System: {article.System}</span>
          <span className="metadata-item">Type: {article.Type}</span>
        </div>
        
        <div className="article-content">
          {article.Long_resume ? (
            <div className="long-resume">{article.Long_resume}</div>
          ) : (
            <div className="no-content">Pas de résumé détaillé disponible</div>
          )}
        </div>
        
        <div className="article-actions">
          <a 
            href={article.Link} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="source-link"
          >
            Voir la source originale
          </a>
        </div>
      </div>
    </div>
  );
};

export default ArticleDetailPage;